import type { AlineText } from '../text/AlineText';

export type Origin = 'INHERITED' | 'USER_APPLIED';

export type ToggleableKeys = 'bold' | 'italic' | 'underline' | 'strikethrough';

export type FormatKeys = keyof Omit<AlineText, 'comments' | 'suggestedEdits' | 'text'>;

export type TextProps = Omit<AlineText, 'text'>;

export type TextPropKeysWithoutComments = FormatKeys | 'suggestedEdits';

export const formatKeys: FormatKeys[] = [
  'bold',
  'italic',
  'underline',
  'strikethrough',
  'fontSize',
  'fontType',
  'fontColor',
  'highlight',
  'verticalAlign',
];

export const textPropKeysWithoutComments: TextPropKeysWithoutComments[] = [
  ...formatKeys,
  'suggestedEdits',
];

export type FontSizeFormat = AlineText['fontSize'];

export type FontTypeFormat = AlineText['fontType'];

export type ColorFormat = AlineText['fontColor'];

export type AlineTextFormats = Omit<AlineText, 'comments' | 'suggestedEdits' | 'text'>;

export type TextPropsWithoutComments = Omit<AlineText, 'comments' | 'text'>;

export type Format = Partial<AlineTextFormats>;
